export default __webpack_public_path__ + "static/media/icon-algowork-n@3x.91494486.webp";